import { rankWith, isObjectControl, isControl } from '@jsonforms/core';
import type {
  UISchemaElement,
  JsonSchema,
  TesterContext,
} from '@jsonforms/core';

export const countryGreetingTester = rankWith(
  4,
  (uischema: UISchemaElement, schema: JsonSchema, context: TesterContext) => {
    if (!isControl(uischema) || !isObjectControl(uischema, schema, context)) {
      return false;
    }

    const path = uischema.scope;
    const propertyName = path.split('/').pop() ?? '';
    const propertySchema = context.rootSchema?.properties?.[propertyName] as
      | JsonSchema
      | undefined;

    if (!propertySchema) {
      return false;
    }

    return (propertySchema as any)?.['x-widget'] === 'country-greeting';
  }
);

export const createCountryGreetingTester = (propertyName: string) =>
  rankWith(
    4,
    (uischema: UISchemaElement, schema: JsonSchema, context: TesterContext) =>
      isControl(uischema) &&
      isObjectControl(uischema, schema, context) &&
      uischema.scope.endsWith(propertyName)
  );
